import { filter } from "lodash";
import { Icon } from "@iconify/react";
import { useEffect, useState } from "react";
import plusFill from "@iconify/icons-eva/plus-fill";
import iconEdit from "@iconify/icons-eva/edit-2-fill";
import iconDelete from "@iconify/icons-eva/person-delete-fill";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
// material
import { Card, Table, Stack, Switch, Button, Checkbox, TableRow, TableBody, TableCell, Container, Typography, TableContainer, TablePagination, RadioGroup, Radio, FormControlLabel, TextField, Avatar, InputAdornment } from "@mui/material";
// components
import Page from "../../components/Page";
import Label from "../../components/Label";
import Scrollbar from "../../components/Scrollbar";
import SearchNotFound from "../../components/SearchNotFound";
import { UserListHead, UserListToolbar } from "../../components/_dashboard/user";
// import USERLIST from '../_mocks_/user';

import axios from "axios";
import { BASE_URL } from "src/config/constants";
import StringUtil from "src/utils/StringUtil";
import MoreMenu from "src/components/common/MoreMenu";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import Uploader from "src/components/uploader/Uploader";
import { alert } from "src/services/alert";
import Confirm from "src/components/common/ConfirmDialog";
import UserInfo from "src/components/common/UserInfo";
import { asyncRequest } from "src/services/network";
import ListToolbar from "src/components/common/ListToolbar";
import MyPagination from "src/components/common/MyPagination";
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: "id", label: "供应商ID", alignRight: false },
  { id: "name", label: "供应商名称", alignRight: false },
  // { id: "user", label: "推荐人", alignRight: false },
  { id: "contact", label: "负责人", alignRight: false },
  { id: "mobile", label: "联系电话", alignRight: false },
  // { id: "uid", label: "对接员ID", alignRight: false },
  // { id: "share", label: "对接员分润（百分比）", alignRight: false },
  { id: "status", label: "状态", alignRight: false },
  { id: "createdAt", label: "添加时间", alignRight: false },
  { id: "" },
];

// ----------------------------------------------------------------------

const moreMenus = [
  { title: "编辑", icon: iconEdit },
  { title: "删除", icon: iconDelete },
];

export default function StoreSupplier() {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState("name");
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const navigate = useNavigate();

  const [action, setAction] = useState("");
  const [targetCategory, setTargetCategory] = useState({});
  const [form, setForm] = useState({
    name: "",
    contact: "",
    mobile: "",
    status: 0,
    remark: "",
    share: "",
  });

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
  });

  useEffect(() => {
    getItems();
  }, [filter]);

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: "/store/supplier/list",
      data: filter,
    });

    setItems(data);
    setTotal(count);
  }

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = items.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  
  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage == filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  };

  function handleAddBanner() {
    setAction("add");
    setForm({
      name: "",
      status: 0,
      pUser: {},
    });
  }

  const handleMoreClick = (type, row) => {
    if (type === "编辑") {
      // navigate(`edit/${row.id}`);
      setTargetCategory({ ...row });
      setAction("edit");
      setForm({
        name: row.name,
        contact: row.contact,
        mobile: row.mobile,
        status: row.status,
        remark: row.remark,
        share: row.share,
        pUser: row.user,
      });
    } else if (type === "删除") {
      handleDelBanner(row.id);
    }
  };

  function handleDelBanner(id) {
    Confirm({
      message: "删除不可恢复，确定删除吗?",
      onConfirm() {
        axios
          .post("/store/supplier/del", { id })
          .then((res) => {
            const { code, msg, data } = res.data;
            if (code === 1) {
              setItems(items.filter((b) => b.id !== id));
            } else {
              alert(msg);
            }
          })
          .catch((err) => {
            console.log("删除分类失败: ", err);
          });
      },
    });
  }

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  function getStatusText(status) {
    switch (status) {
      case 0:
        return "等待审核";
      case 1:
        return "通过审核";
      case 2:
        return "审核失败";
    }
  }

  function getStatusColor(status) {
    switch (status) {
      case 0:
        return "error";
      case 1:
        return "success";
      case 2:
        return "warning";
    }
  }

  function handleDialogConfirm() {
    if (!form.name) return alert("分类名称不能为空");
    if (!form.pUser) return alert("请选择平台用户");

    const formData = {
      ...form,
      // uid: form.pUser.uid,
    };

    formData.status = parseInt(formData.status);

    if (action === "edit") {
      formData.id = targetCategory.id;
    }

    axios
      .post(action === "add" ? "/store/supplier/add" : "/store/supplier/edit", formData)
      .then((res) => {
        const { code, msg, data } = res.data;
        if (code === 1) {
          if (action === "add") {
            setItems([...items, data]);
          } else if (action === "edit") {
            const category = items.find((b) => b.id === targetCategory.id);
            // category.icon = formData.icon;
            // category.is_show = parseInt(formData.is_show);

            Object.assign(category, formData);
            setItems([...items]);
          }

          setAction("");
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log("添加或修改分类失败: ", err);
      });
  }

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - items.length) : 0;

  const isUserNotFound = items.length === 0;

  return (
    <Page title="供应商">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            供应商
          </Typography>

          <Button variant="contained" to="add" startIcon={<Icon icon={plusFill} />} onClick={handleAddBanner}>
            添加供应商
          </Button>
        </Stack>

        <Card>
          <ListToolbar numSelected={selected.length} filterName={filter.search} onFilterName={handleFilterByName} onRefresh={getItems} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead order={order} orderBy={orderBy} headLabel={TABLE_HEAD} rowCount={items.length} numSelected={selected.length} onSelectAllClick={handleSelectAllClick} onRequestSort={() => {}} />

                <TableBody>
                  {items.map((row) => {
                    // const { id, name, role, status, company, avatarUrl, isVerified } = row;
                    const { id, uid, name, contact, mobile, share, status, user, pUser, createdAt } = row;
                    const isItemSelected = selected.indexOf(name) !== -1;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={isItemSelected} aria-checked={isItemSelected}>
                        <TableCell align="left">{id}</TableCell>
                        <TableCell align="left">{name}</TableCell>
                        {/* <TableCell component="th" scope="row">
                          <UserInfo {...user} />
                        </TableCell> */}
                        <TableCell align="left">{contact}</TableCell>
                        <TableCell align="left">{mobile}</TableCell>
                        {/* <TableCell component="th" scope="row">
                          <UserInfo {...user} />
                        </TableCell> */}
                        {/* <TableCell align="left">{share}</TableCell> */}
                        {/* <TableCell align="left">{status}</TableCell> */}
                        <TableCell align="left">
                          <Label variant="ghost" color={getStatusColor(status)}>
                            {getStatusText(status)}
                          </Label>
                        </TableCell>

                        <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>

                        <TableCell align="right">
                          <MoreMenu spread menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filter.search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
          {/* <TablePagination labelRowsPerPage="每页行数" rowsPerPageOptions={[20, 50]} component="div" count={items.length} rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage} /> */}
        </Card>
      </Container>

      <FormDialog title={action === "add" ? "添加供应商" : "修改供应商"} open={!!action} onClose={() => setAction()} onConfirm={handleDialogConfirm}>
        <FormItem title="供应商名称" required>
          <TextField fullWidth placeholder="请输入供应商名称" autoComplete="off" id="name" value={form.name} size="small" onChange={(e) => handleIptChange("name", e.target.value)} />
        </FormItem>
        {/* 
        <FormItem title="平台用户" required>
          <Stack
            onClick={() => {
              UserPicker({
                onSelect(user) {
                  handleIptChange("pUser", user);
                  console.log(user);
                },
              });
            }}
          >
            <UserInfo {...form.pUser} />
          </Stack>
        </FormItem> */}

        <FormItem title="负责人">
          <TextField fullWidth placeholder="请输入负责人" autoComplete="off" id="contact" value={form.contact} size="small" onChange={(e) => handleIptChange("contact", e.target.value)} />
        </FormItem>

        <FormItem title="联系方式">
          <TextField fullWidth placeholder="请输入联系方式" autoComplete="off" id="mobile" value={form.mobile} size="small" onChange={(e) => handleIptChange("mobile", e.target.value)} />
        </FormItem>

        <FormItem title="供应商状态" required>
          <RadioGroup row aria-label="gender" name="row-radio-buttons-group" value={form.status}>
            <FormControlLabel value={0} control={<Radio />} label="审核中" onChange={(e) => handleIptChange("status", e.target.value)} />
            <FormControlLabel value={1} control={<Radio />} label="审核通过" onChange={(e) => handleIptChange("status", e.target.value)} />
            <FormControlLabel value={2} control={<Radio />} label="审核失败" onChange={(e) => handleIptChange("status", e.target.value)} />
          </RadioGroup>
        </FormItem>

        {/* <FormItem title="对接员分润">
          <TextField fullWidth placeholder="请输入对接员分润" autoComplete="off" type="number" id="share" value={form.share} size="small" onChange={(e) => handleIptChange("share", e.target.value)} 
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>
            }}
          />
        </FormItem> */}

        <FormItem title="备注">
          <TextField fullWidth placeholder="请输入备注信息" rows={5} multiline autoComplete="off" id="remark" value={form.remark} size="small" onChange={(e) => handleIptChange("remark", e.target.value)} />
        </FormItem>
      </FormDialog>
    </Page>
  );
}
